import { createStore, applyMiddleware, combineReducers } from 'redux';
import { passwordRecoverReducer as passwordRecover } from './reducer';
import { reducer as onionForm } from '4finance-onion-form';
import { reducer as translate } from '4finance-translate';
import apiMiddleware from './apiMiddleware';
import tryCountStoreMiddleware from './tryCountStoreMiddleware';
var api = apiMiddleware();
var tryCountStore = tryCountStoreMiddleware();
var store = createStore(combineReducers({
  passwordRecover: passwordRecover,
  onionForm: onionForm,
  translate: translate
}), applyMiddleware(api, tryCountStore));
export default store;